module.exports = __webpack_public_path__ + "img/00045.edd6c455.webp";